import { useMemo, useCallback } from 'react';
import { registerMutation, registerQuery, useMutation, useQuery } from 'data-fetching-client';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { companiesPath } from '../../consts';
import noPortalClient from 'hub-http/clients/noPortalApiClient';
const GET_COMPANIES = registerQuery({
  fieldName: 'companies',
  args: ['offset', 'count', 'query'],

  fetcher({
    offset,
    count,
    query
  }) {
    return noAuthApiClient.get(`${companiesPath}/search`, {
      query: Object.assign({
        offset,
        count
      }, query && {
        query
      })
    });
  }

});
export const ADD_COMPANY = registerMutation({
  fieldName: 'addCompany',
  args: ['companyName'],

  fetcher({
    companyName
  }) {
    return noPortalClient.post(`${companiesPath}/`, {
      data: {
        name: companyName
      }
    });
  }

});
export const useAddCompany = () => {
  const [addCompany, {
    loading: addCompanyLoading,
    data
  }] = useMutation(ADD_COMPANY, {});
  return {
    addCompany,
    addCompanyLoading,
    newCompany: data
  };
};
export const useCompanies = () => {
  const {
    data,
    error: companiesError,
    loading: companiesLoading,
    fetchMore
  } = useQuery(GET_COMPANIES, {
    variables: {
      offset: 0,
      count: 50,
      query: ''
    }
  });
  const companies = useMemo(() => data ? data.companies : {
    hasMore: false,
    offset: 0,
    total: 0,
    results: []
  }, [data]);
  const getCompanies = useCallback((query, offset) => {
    return fetchMore({
      variables: {
        query,
        offset,
        count: 50
      }
    }).then(response => {
      return response.data.companies;
    });
  }, [fetchMore]);
  return {
    companies,
    companiesError,
    companiesLoading,
    getCompanies
  };
};